<template>
  <TableBodyRow
    :id="`saved-filters_table_row_${index}`"
    :thead="thead"
    class="gw_table_body_row_hoverable gw_hvr"
    :class="[
      {
        gw_table_body_row_dragged: draggedItems.some(i => (i ? i.id === item.id : false)),
      },
    ]"
    @click="$emit('apply:filter')"
  >
    <TableBodyCell
      style="
        --max-width-td: 2.5rem;
        --min-width-td: 2.5rem;
        --padding-td: 0;
        justify-content: center;
      "
    >
      <div
        @mousedown="startDrag"
        @touchstart="startDrag"
      >
        <div
          :class="dragDisabled ? 'clr-black-4 icon_btn_disabled cursor-not-allowed' : 'cursor-grab'"
          class="mdi mdi-drag-vertical pa-1 csst csst_nm csst_active-hide-content icon_btn clr-grey"
        >
          <div
            class="csst_content clr-white text-nowrap"
            :style="dragDisabled ? `background:var(--clr-error)` : ''"
            style="line-height: 1.2; left: calc(100% + 0.5rem)"
            v-html="
              dragDisabled
                ? $t('tooltips.drag_drop_disable_enable_sort')
                : $t('tooltips.drill_drag_drop_change_order')
            "
          ></div>
        </div>
      </div>
    </TableBodyCell>
    <TableBodyCell
      style="
        --min-width-td: 2.5rem;
        --max-width-td: 2.5rem;
        --padding-td: 0;
        justify-content: center;
      "
      @click.stop
    >
      <Checkbox
        class="csst csst_nm flgmfslctr_title_controls_item"
        style="
          --icon-size: 1.25rem;
          --clr-disabled: var(--clr-grey-2);
          --clr-enabled: var(--clr-primary);
        "
        :value="isSelected"
        @click="$emit('toggle:selected')"
      >
        <template #content>
          <div
            class="csst_content clr-white"
            style="line-height: 1.2; left: calc(100% + 0.5rem)"
            v-html="$t('common.select')"
          />
        </template>
      </Checkbox>
    </TableBodyCell>
    <TableBodyCell
      thKey="name"
      style="--padding-td: 0 0.5rem 0 0.25rem"
      @click.stop
    >
      <GwTableInputMenu
        :text="item.name"
        @confirm="text => text && patchName(text)"
      >
        <template #text>
          <div
            class="truncate"
            :title="item.name"
          >
            {{ item.name }}
          </div>
        </template>
      </GwTableInputMenu>
    </TableBodyCell>
    <TableBodyCell thKey="note">
      <div
        class="truncate"
        style="max-width: 100%"
      >
        {{ item.description }}
      </div>
    </TableBodyCell>
    <TableBodyCell thKey="tags">
      <GwMenu
        placement="bottom-start"
        :flOptions="{ offset: 0, padding: 0 }"
        style="max-width: 100%"
        :ignoreDataGwmenu="true"
        @click.stop
      >
        <template #opener>
          <TagsTableCellList
            class="gw_btn_hover_back"
            :tags="item.tags"
            style="max-width: 100%"
          />
        </template>
        <template #default>
          <TagsManager
            data-gwmenu="noclose"
            style="box-shadow: var(--menu-shadow)"
            :inputAutofocus="!mobile"
            :tagIds="item.tags.map(t => t.id)"
            :tagType="tagType"
            :allTags="allTags"
            :hasAnyAll="false"
            @click:tag="tag => $emit('click:tag_item', tag)"
          />
        </template>
      </GwMenu>
    </TableBodyCell>

    <TableBodyCell
      thKey="actions"
      class="gw_table_body_cell_stickys gw_table_body_cell_sticky-noshadow"
      style="order: 99; --z-index-td-sticky-left: unset; --z-index-td-sticky-right: 0"
      data-tst="saved_filters_table_row_apply"
    >
      <div
        class="f-center h-100 ml-auto gw_hvr_content"
        style="right: 0.25rem; gap: 0.25rem"
      >
        <div
          class="gw_btn text-medium weight_500"
          @click.stop="$emit('open:detail')"
        >
          <div class="mdi mdi-pencil mr-1"></div>
          {{ $t('btn.edit') }}
        </div>
        <div class="gw_btn text-medium weight_500">
          <div class="mdi mdi-chevron-double-right mr-1"></div>
          {{ $t('btn.apply') }}
        </div>
      </div>
    </TableBodyCell>
  </TableBodyRow>
</template>

<script>
import Checkbox from '@/components/Common/Checkbox/Checkbox'
import TagsManager from '@/components/TagsManager/TagsManager'
import TagsTableCellList from '@/components/TagsManager/TagsTableCellList'
import GwMenu from '@/components/lib/GwMenu'
import GwTableInputMenu from '@/components/DataTables/v2/GwTableInputMenu'
import TableBodyRow from '@/components/DataTables/v2/TableBodyRow'
import TableBodyCell from '@/components/DataTables/v2/TableBodyCell'
import table_mix from '@/components/DataTables/table_mix'
import float_mix from '@/mixins/float_mix'

export default {
  name: 'SavedFiltersTableV2Row',

  components: {
    TableBodyRow,
    TableBodyCell,
    Checkbox,
    TagsManager,
    TagsTableCellList,
    GwMenu,
    GwTableInputMenu,
  },
  mixins: [table_mix, float_mix],
  props: {
    item: Object,
    index: Number,
    thead: Object,
    isActive: Boolean,
    isSelected: Boolean,
    mobile: Boolean,
    allTags: Array,
    tagType: String,

    draggedItems: Array,
    dragDisabled: Boolean,
  },
  emits: [
    'toggle:selected',
    'click:tag_item',
    'apply:filter',
    'drag:start',
    'patch:name',
    'open:detail',
  ],
  data() {
    return {}
  },
  methods: {
    startDrag(e) {
      if (this.dragDisabled) return
      this.$emit('drag:start', e)
    },
    patchName(text) {
      this.$emit('patch:name', { item: this.item, name: text })
    },
  },
}
</script>
